import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Brand } from '../Model/Dto/Brand/Brand';
import { BrandService } from '../Services/Brands/brand.service';
import { LoginService } from '../Services/login.service';
import { SystemService } from '../Services/system.service';
import { ProductDataSource } from '../Model/dataProcess/productDataSource';
import { DataSourcesService } from '../Services/DataProcess/datasources.service';
import { BeforeSendEvent } from 'devextreme/ui/file_uploader';
import { OAuthService } from 'angular-oauth2-oidc';
import { DxFileUploaderTypes } from 'devextreme-angular/ui/file-uploader';
import { RowRemovedEvent } from 'devextreme/ui/data_grid';

@Component({
  selector: 'brands',
  templateUrl: './brands.component.html',
  styleUrl: './brands.component.css'
})
export class BrandsComponent implements OnInit, AfterViewInit {
  brands: Brand[] = [];
  productDataSources: ProductDataSource[] = [];
  newOrUpdateBrand: Brand = {};
  isAddPopupVisible: boolean = false;
  addOrUpdateVisible = false;
  editMode = false;

  constructor(
    public brandService: BrandService,
    public loginService: LoginService,
    public systemService: SystemService,
    public dataSourcesService: DataSourcesService,
    public oAuthService: OAuthService
  ) {
    this.addBrand = this.addBrand.bind(this);
    this.addOrUpdateBrand = this.addOrUpdateBrand.bind(this);
  }

  ngOnInit() {
    this.newOrUpdateBrand = {};
    this.reloadBrands();       
  }

  async ngAfterViewInit() {
    this.productDataSources = await this.dataSourcesService.getAll(this.loginService.currentCustomer.id);
  }

  onContentToolbarPreparing(e) {
    e.toolbarOptions.items.unshift({
      location: 'before',
      locateInMenu: 'auto',
      template: 'addBrandTemplate',
    });
  }

  async reloadBrands() {
    this.brands = await this.brandService.getBrands(this.loginService.currentCustomer.id);
  }

  addOrUpdateBrand(brand?: Brand) {
    this.newOrUpdateBrand = {};
    this.editMode = false;
    if (brand) {
      this.newOrUpdateBrand = brand;
      this.editMode = true;
    }
    this.addOrUpdateVisible = true;
  }

  addBrand(): void {
    this.brandService.updateOrCreateBrand(this.newOrUpdateBrand, this.loginService.currentCustomer.id).then((result: Brand) => {
      if (this.editMode)
        this.systemService.notifyInfo("Marke wurde geändert");
      else {
        this.systemService.notifyInfo("Marke wurde angelegt");
      }
      this.reloadBrands();
    });

    this.addOrUpdateVisible = false;
  }

  onDataSourceSelectionChanged(e) {
    this.newOrUpdateBrand.dataSources = e.selectedRowKeys;
  }

  onBeforeSendUpload(event: BeforeSendEvent) {
    event.request.withCredentials = true;
    event.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
  }

  async onRowRemoved(event: RowRemovedEvent) {
    let key = event.key;
    await this.brandService.delete(key, this.loginService.currentCustomer.id);
    this.reloadBrands();
  }

  async onUploaded(e: DxFileUploaderTypes.UploadedEvent) {
    this.newOrUpdateBrand.logoFile = e.request.responseText as string;
    this.reloadBrands();
  }

}
